"use strict";

module.exports = function (column) {
  return this.opts.listColumns.hasOwnProperty(column);
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2-premium/compiled/methods/is-list-filter.js
// module id = 911
// module chunks = 0